import { withRouter } from 'react-router-dom'
import { NewPackPage as Page } from './NewPackPage'

export const NewPackPage = withRouter(Page) as React.FC<{}>
